import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class IndicatorService {
  indicating = new BehaviorSubject(false);
  mode$ = this.indicating.pipe(map((bool) => (bool ? 'indeterminate' : 'determinate')));
}
